export default "__VITE_ASSET__D25kduRw__"